import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-lg text-center">
        <h1 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#2C2A28]">
          No worries — <em className="italic text-[#8A5A44]">nothing was charged.</em>
        </h1>
        <p className="mt-6 text-[#5C5854] font-light leading-relaxed">
          The door is always open, whether you give or not. The coaching is free either way.
        </p>
        <Link
          to="/"
          className="inline-block mt-10 rounded-full bg-[#8A5A44] hover:bg-[#734A38] text-[#FAF9F6] px-8 py-3.5 text-sm transition-colors duration-300"
          data-testid="cancel-back-home"
        >
          Back to the ministry
        </Link>
      </div>
    </div>
  );
}
